import React, { useState, useEffect } from 'react';
import { Button, Box, Modal, Typography, Grid, Stack, Divider, Card, CardContent } from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Iconify from '../../../components/iconify';
import { Api, UploadFile } from '../../../webservices';

const Signature = () => {
    const navigate = useNavigate();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [name, setName] = useState('');
    const [signList, setSignList] = useState([]);
    const [selectedSignatureId, setSelectedSignatureId] = useState('');

    const [modalOpen, setModalOpen] = useState(false);

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const [modalOpen1, setModalOpen1] = useState(false);

    const handleOpenModal1 = () => {
        setModalOpen1(true);
    };

    const handleCloseModal1 = () => {
        setModalOpen1(false);
    };

    useEffect(() => {
        GetSign();
    }, []);

    const handleOpenDeleteModal = (signatureId) => {
        setSelectedSignatureId(signatureId);
        setDeleteModalOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setDeleteModalOpen(false);
    };

    const AddSign = () => {
        if (!name.trim()) {
            toast.warn('Please fill input field!');
            return;
        }

        const body = {
            "name": name,
        };
        const token = localStorage.getItem("token");
        Api('email/signature/set', 'POST', body, token).then((Response) => {
            if (Response.status === 200) {
                if (Response.data.code === 200) {
                    toast.success("Signature added successfully!");
                    GetSign();
                    setName('');
                    handleCloseModal1();
                } else {
                    toast.warn(`${Response.data.status}!`);
                }
            } else {
                toast.warn('Error!');
            }
        });
    };

    const GetSign = () => {
        const token = localStorage.getItem('token');
        Api('email/signature/getAll', 'GET', '', token).then((response) => {
            if (response.status === 200) {
                if (response.data.code === 200) {
                    setSignList(response.data.result);
                    localStorage.setItem('sign', response.data.result[0].signature.name);
                } else {
                    // console.log('data:', response.data.message);
                }
            }
        });
    };

    const DeleteSign = () => {
        const body = {
            "signatureId": selectedSignatureId,
        };
        const token = localStorage.getItem("token");
        Api('email/signature/delete', 'POST', body, token).then((Response) => {
            if (Response.status === 200) {
                if (Response.data.code === 200) {
                    toast.success("Signature deleted successfully!");
                    GetSign();
                    handleCloseDeleteModal();
                } else {
                    toast.warn(`${Response.data.status}!`);
                }
            } else {
                toast.warn('Error!');
            }
        });
    };
    
    const [updatedName, setUpdatedName] = useState('');
    const [selectedSignature, setSelectedSignature] = useState(null);

    const handleUpdateNameChange = (event, editor) => {
        const data = editor.getData();
        setUpdatedName(data);
    };

    const handleOpenUpdateModal = (signature) => {
        setSelectedSignature(signature);
        setUpdatedName(signature.signature.name);
        setModalOpen(true);
    };

    const UpdateSign = () => {
        if (!updatedName.trim()) {
            toast.warn('Please fill input field!');
            return;
        }

        const body = {
            signatureId: selectedSignature._id,
            name: updatedName,
        };

        const token = localStorage.getItem("token");
        Api('email/signature/update', 'POST', body, token).then((Response) => {
            if (Response.status === 200) {
                if (Response.data.code === 200) {
                    toast.success("Signature updated successfully!");
                    GetSign();
                    handleCloseModal();
                } else {
                    toast.warn(`${Response.data.status}!`);
                }
            } else {
                toast.warn('Error!');
            }
        });
    };

    // const [imagePreview, setImagePreview] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const modalOpene = () => {
        setShowModal(true)
    }
    const modalClosee = () => {
        setShowModal(false)
    }
    const [loading, setLoading] = useState('')
    const [fileInputFiles, setFileInputFiles] = useState();

    const handleFileSelect = (e) => {
        setLoading("Please wait...")
        const file = e.target.files[0];
        setFileInputFiles(file);
        if (file) {
            uploadMulti(file);
        }
    };

    const uploadMulti = async (file) => {
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('document', file);
        formData.append('directoryName', 'profile');
        try {
            const response = await UploadFile('resume/upload_resume', formData, token);
            if (response.status === 200 && response.data.code === 200) {
                const uploadedImageUrl = response.data.filePath;
                //   setProfileImage(uploadedImageUrl);  
                UploadImage(uploadedImageUrl)
                //   setImagePreview(URL.createObjectURL(file));  
            } else {
                //   toast.warn(response.data.status + '!');
            }
        } catch (error) {
            // toast.warn('Error uploading the image!');
        }
    };
    
    const UploadImage = (parseres) => {
        const body = {
            "profileUrl": parseres
        }
        const token = localStorage.getItem("token")
        Api('company/uploadProfileImage', 'POST', body, token)
            .then((Response) => {
                if (Response.status === 200) {
                    modalClosee()
                    setFileInputFiles('')
                    setLoading('')
                    toast.success(Response.data.resmessage);
                    localStorage.setItem("image", Response.data.profileUrl)
                    // console.log("Profile image uploaded successfully!");
                } else {
                    // console.error(`Error uploading profile image: ${Response.statusText}`);
                }
            })
            .catch((error) => {
                // console.error("Error during upload: ", error);
            });
    };

    return (
        <>
        <Helmet>
        <title> Setting | Foxearch </title>
      </Helmet>
            <Modal
                open={modalOpen1}
                onClose={handleCloseModal1}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: "50%",
                    bgcolor: 'background.paper',
                    border: '3px solid #3C6BA5',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 3,
                }}>
                    <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
                        Add Signature
                    </Typography>
                    <Divider sx={{ mb: 2, mt: 1 }} />
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <CKEditor
                            editor={ClassicEditor}
                            data={name}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setName(data);
                            }}
                        />
                    </Grid>
                    <Stack flexDirection={'row'} gap={1} mt={2} sx={{ justifyContent: 'center' }}>
                        <Button color="custom" variant="contained" onClick={AddSign}>
                            Add
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={deleteModalOpen}
                onClose={handleCloseDeleteModal}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: "30%",
                    bgcolor: 'background.paper',
                    border: '3px solid #3C6BA5',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 3,
                }}>
                    <Typography variant="h6" color={'#3C6BA5'} textAlign={'center'}>
                        Are you sure you want to delete this signature?
                    </Typography>
                    <Stack flexDirection={'row'} gap={2} mt={2} sx={{ justifyContent: 'center' }}>
                        <Button color="custom" variant="contained" onClick={DeleteSign}>
                            Yes
                        </Button>
                        <Button color="custom" variant="contained" onClick={handleCloseDeleteModal}>
                            No
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={modalOpen}
                onClose={handleCloseModal}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: "50%",
                    bgcolor: 'background.paper',
                    border: '3px solid #3C6BA5',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 3,
                }}>
                    <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
                        {selectedSignature ? "Update Signature" : "Add Signature"}
                    </Typography>
                    <Divider sx={{ mb: 2, mt: 1 }} />
                    <CKEditor
                        editor={ClassicEditor}
                        data={updatedName}
                        onChange={handleUpdateNameChange}
                    />
                    <Stack flexDirection={'row'} gap={1} mt={2} sx={{ justifyContent: 'center' }}>
                        <Button color="custom" variant="contained" onClick={selectedSignature ? UpdateSign : AddSign}>
                            {selectedSignature ? "Update" : "Add"}
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={showModal}
                onClose={modalClosee}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '30%',
                    backgroundColor: 'white',
                    border: '4px solid #1E74B3',
                    borderRadius: '13px',
                    padding: '1rem',
                    outline: 'none',
                    height: 'auto'
                }}>

                    {/* <Typography 
                   variant="contained" textAlign={'center'} fontSize={"1rem"}>
                   Upload Profile Image 
                   </Typography> */}
                    <Typography
                        variant="body1"
                        sx={{
                            mx: 'auto', textAlign: 'center', fontWeight: "bold",
                            fontSize: "20px", color: '#3C6BA5',
                        }}

                    >
                        {loading}
                    </Typography>

                    <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                        <div
                            style={{
                                border: '3px dashed #1E74B3',
                                padding: '10px',
                                borderRadius: '15px',
                                margin: '1rem',
                                // justifyContent: 'center',
                                // alignItems: 'center',
                                textAlign: 'center',
                                color: '#1E74B3',
                                // width: '330px',
                                marginLeft: '25',
                                alignContent: 'center',
                            }}
                        >
                            <Typography variant="body1" fontWeight="bold" mb={1} mt={1}>
                                Upload Image
                            </Typography>
                            <input
                                id="file-upload"
                                type="file"
                                style={{ display: 'none' }}
                                accept="image/png, image/jpeg, image/jpg"
                                onChange={handleFileSelect}
                            //   single
                            />

                        </div>
                    </label>
                    {/* <div> */}
                    {/* {/ <Typography variant="body1">Uploaded Files</Typography> /} */}
                    <Typography
                        variant="body1"
                        sx={{ mx: 'auto', textAlign: 'center' }}

                    >
                        {fileInputFiles?.name}
                    </Typography>

                    {/* </div> */}
                </Box>
            </Modal>
            <Stack>
                <Iconify icon="ion:arrow-back" fontSize={30}
                    sx={{
                        cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem',
                        fontWeight: '600', mb: 1
                    }} onClick={() => navigate(-1)} />
            </Stack>
            <Button color="custom" variant="contained" onClick={handleOpenModal1}
                disabled={signList?.length === 1}
                sx={{}}>
                Add Signature
            </Button>
            <Button
                color="custom"
                variant="contained"
                disabled={localStorage.getItem("role") === "superadmin"}
                sx={{ ml: 2 }}
                onClick={() => modalOpene()}
            >
                Add Profile
            </Button>

            {/* {localStorage.getItem("role" === "superadmin") && (

<Button color="custom" variant="contained" 
sx={{ml:2}}
onClick={() => modalOpene()}>
    Add Profle
</Button>
)} */}

            <Box sx={{ mt: -1 }}>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    {signList.length > 0 ? (
                        signList.map((item) => (
                            <Grid item xs={12} sm={6} md={4} key={item._id}>
                                <Card
                                    sx={{
                                        border: '1px solid #1E74B3',
                                        transition: 'transform 0.3s, box-shadow 0.3s',
                                        width: 400,
                                        height: 200,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        '&:hover': {
                                            transform: 'scale(1.01)',
                                            boxShadow: '0 5px 10px rgba(0,0,0,0.2)',
                                            border: '1px solid #1E74B3',
                                        },
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            flex: 1,
                                            overflowY: 'auto',
                                        }}
                                    >
                                        <Typography variant="body1" sx={{ fontWeight: "bold" }} dangerouslySetInnerHTML={{ __html: item.signature.name }} />
                                    </CardContent>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ mt: 'auto', mb: 1, display: 'flex', justifyContent: 'center', gap: 3 }}>
                                        <Button color="custom" variant="contained" onClick={() => handleOpenUpdateModal(item)}>
                                            Update
                                        </Button>
                                        <Button color="custom" variant="contained" onClick={() => handleOpenDeleteModal(item._id)}>
                                            Delete
                                        </Button>
                                    </Box>
                                </Card>
                            </Grid>
                        ))
                    ) : null}
                </Grid>
            </Box>

            <ToastContainer />
        </>
    );
};

export default Signature;
